import Vue from 'vue'
import Router from 'vue-router'
import dashboard from '@/components/dashboard/dashboard'
import home from '@/components/common/home'
const loginpage = resolve => require(['@/components/login/login'], resolve)

Vue.use(Router)

let router = new Router({
	routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: () => import('../components/common/home.vue'),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/dashboard',
                    component: () => import('../components/dashboard/dashboard.vue'),
                    meta: {
                        title: '系统首页',
                        isAlive: true
                    }
                },{
                    path: '/yardManage',
                    component: () => import('../components/yardManage/yardManage.vue'),
                    meta: {
                        title: '院落管理',
                        isAlive: true
                    }
                },{
                    path: '/yardHousehold',
                    component: () => import('../components/yardHousehold/yardHousehold.vue'),
                    meta: {
                        title: '院落住户',
                        isAlive: true
                    }
                },
                {
                    path: '/organization',
                    component: () => import('../components/systemSettings/organization/organization.vue'),
                    meta: {
                        title: '院落机构',
                        isAlive: true
                    }
                },{
                    path: '/auditUser',
                    component: () => import('../components/yardHousehold/auditUser/auditUser.vue'),
                    meta: {
                        title: '用户审核',
                        isAlive: false
                    }
                },{
                    path: '/costProject',
                    component: () => import('../components/yardCost/costProject/costProject.vue'),
                    meta: {
                        title: '费用科目',
                        isAlive: true
                    }
                },
                {
                    path: '/budget',
                    component: () => import('../components/yardCost/budget/budget.vue'),
                    meta: {
                        title: '院落预算',
                        isAlive: true
                    }
                },
                {
                    path: '/costConfiscate',
                    component: () => import('../components/yardCost/costConfiscate/costConfiscate.vue'),
                    meta: {
                        title: '费用收缴',
                        isAlive: true
                    }
                },
                {
                    path: '/pay',
                    component: () => import('../components/yardCost/pay/pay.vue'),
                    meta: {
                        title: '支出费用',
                        isAlive: true
                    }
                },
                {
                    path: '/account',
                    component: () => import('../components/yardCost/account/account.vue'),
                    meta: {
                        title: '费用账号',
                        isAlive: true
                    }
                },
                {
                    path: '/notice',
                    component: () => import('../components/notice/notice.vue'),
                    meta: {
                        title: '消息发布',
                        isAlive: true
                    }
                },
                {
                    path: '/notice&Info',
                    component: () => import('../components/notice/noticeInfo/noticeInfo.vue'),
                    meta: {
                        title: '公告详情',
                        isAlive: false
                    }
                },
                {
                    path: '/feedback',
                    component: () => import('../components/feedback/feedback.vue'),
                    meta: {
                        title: '问题反馈',
                        isAlive: true
                    }
                },
                {
                    path: '/questionnaire',
                    component: () => import('../components/questionnaire/questionnaire.vue'),
                    meta: {
                        title: '问卷调查',
                        isAlive: true
                    }
                },
                // {
                //     path: '/nucleicTest',
                //     component: () => import('../components/antiepidemic/nucleicTest/nucleicTest.vue'),
                //     meta: {
                //         title: '核酸检测',
                //         isAlive: true
                //     }
                // },
                // {
                //     path: '/volunteer',
                //     component: () => import('../components/antiepidemic/volunteer/volunteer.vue'),
                //     meta: {
                //         title: '防疫志愿者',
                //         isAlive: true
                //     }
                // },
                {
                    path: '/antiepidemicPeople',
                    component: () => import('../components/antiepidemic/antiepidemicPeople/antiepidemicPeople.vue'),
                    meta: {
                        title: '防疫志愿者',
                        isAlive: true
                    }
                },
                {
                    path: '/communityReporting',
                    component: () => import('../components/antiepidemic/communityReporting/communityReporting.vue'),
                    meta: {
                        title: '社区报备',
                        isAlive: true
                    }
                },
                {
                    path: '/detectionPoint',
                    component: () => import('../components/antiepidemic/detectionPoint/detectionPoint.vue'),
                    meta: {
                        title: '核酸检测点',
                        isAlive: true
                    }
                },
                {
                    path: '/reportRoommate',
                    component: () => import('../components/antiepidemic/reportRoommate/reportRoommate.vue'),
                    meta: {
                        title: '报备同住人',
                        isAlive: true
                    }
                },
                {
                    path: '/riskArea',
                    component: () => import('../components/antiepidemic/riskArea/riskArea.vue'),
                    meta: {
                        title: '风险区域',
                        isAlive: true
                    }
                },
                {
                    path: '/epidemicInformation',
                    component: () => import('../components/antiepidemic/epidemicInformation/epidemicInformation.vue'),
                    meta: {
                        title: '疫情资讯',
                        isAlive: true
                    }
                },
                // {
                //     path: '/yellowred',
                //     component: () => import('../components/antiepidemic/yellowred/yellowred.vue'),
                //     meta: {
                //         title: '黄红码处置',
                //         isAlive: true
                //     }
                // },
                // {
                //     path: '/point',
                //     component: () => import('../components/antiepidemic/point/point.vue'),
                //     meta: {
                //         title: '检测点位',
                //         isAlive: true
                //     }
                // },
                // {
                //     path: '/flow',
                //     component: () => import('../components/antiepidemic/point/flow/flow.vue'),
                //     meta: {
                //         title: '增加流程',
                //         isAlive: false
                //     }
                // },
                // {
                //     path: '/post',
                //     component: () => import('../components/antiepidemic/post/post.vue'),
                //     meta: {
                //         title: '防疫岗位',
                //         isAlive: true
                //     }
                // },
                // {
                //     path: '/postAdd',
                //     component: () => import('../components/antiepidemic/post/postAdd/postAdd.vue'),
                //     meta: {
                //         title: '增加岗位培训',
                //         isAlive: false
                //     }
                // },
                // {
                //     path: '/volunteerAdd',
                //     component: () => import('../components/antiepidemic/post/volunteerAdd/volunteerAdd.vue'),
                //     meta: {
                //         title: '志愿者招募',
                //         isAlive: false
                //     }
                // },
                // {
                //     path: '/material',
                //     component: () => import('../components/antiepidemic/material/material.vue'),
                //     meta: {
                //         title: '防疫物资',
                //         isAlive: true
                //     }
                // },
                {
                    path: '/warehouseMaterials',
                    component: () => import('../components/antiepidemic/material/warehouseMaterials/warehouseMaterials.vue'),
                    meta: {
                        title: '仓库物资',
                        isAlive: false
                    }
                },
                {
                    path: '/warehouseOutIn',
                    component: () => import('../components/antiepidemic/material/warehouseOutIn/warehouseOutIn.vue'),
                    meta: {
                        title: '仓库出入库',
                        isAlive: false
                    }
                },
                {
                    path: '/warehouseStock',
                    component: () => import('../components/antiepidemic/material/warehouseStock/warehouseStock.vue'),
                    meta: {
                        title: '物资库存',
                        isAlive: false
                    }
                },
                {
                    path: '/epidemic',
                    component: () => import('../components/reportedData/epidemic/epidemic.vue'),
                    meta: {
                        title: '疫情防控',
                        isAlive: true
                    }
                },
                {
                    path: '/oldReform',
                    component: () => import('../components/reportedData/oldReform/oldReform.vue'),
                    meta: {
                        title: '老旧小区改造',
                        isAlive: true
                    }
                },
                {
                    path: '/form',
                    component: () => import('../components/form/form.vue'),
                    meta: {
                        title: '新建表单',
                        isAlive: true
                    }
                },
                {
                    path: '/form&attribute',
                    component: () => import('../components/form/attribute/attribute.vue'),
                    meta: {
                        title: '属性信息',
                        isAlive: false
                    }
                },
                {
                    path: '/questionnaire&info',
                    component: () => import('../components/questionnaire/info/info.vue'),
                    meta: {
                        title: '问卷详情',
                        isAlive: false
                    }
                },
                {
                    path: '/topic',
                    component: () => import('../components/topic/topic.vue'),
                    meta: {
                        title: '话题',
                        isAlive: true
                    }
                },
                {
                    path: '/topic&info',
                    component: () => import('../components/topic/topicInfo/topicInfo.vue'),
                    meta: {
                        title: '话题详情',
                        isAlive: false
                    }
                },
                {
                    path: '/SMSconfiguration',
                    component: () => import('../components/systemSettings/SMSconfiguration/SMSconfiguration.vue'),
                    meta: {
                        title: '短信配置',
                        isAlive: true
                    }
                },
                {
                    path: '/userManagement',
                    component: () => import('../components/systemSettings/userManagement/userManagement.vue'),
                    meta: {
                        title: '用户管理',
                        isAlive: true
                    }
                },
                {
                    path: '/logManagement',
                    component: () => import('../components/systemSettings/logManagement/logManagement.vue'),
                    meta: {
                        title: '日志管理',
                        isAlive: true
                    }
                }
            ]
        },
        {
            path: '/login',
            component: () => import('../components/login/login.vue'),
            meta: { title: '登录' }
        }
    ]
});

//是否已经登录
router.beforeEach((to, from, next) => {
	if(to.path.startsWith('/login')) {
		window.sessionStorage.removeItem('access-token');
		next();
	} else {
		let token = window.sessionStorage.getItem('access-token');
		if(!token) {
			//未登录  跳回主页面
			next({
				path: '/login'
			});
		} else {
			next();
		}
	}
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js